import { createApp } from 'vue'
import Playground from './Playground.vue'

// 视觉层自身的样式
import '../theme/theme.css'
import '../theme/recipes.css'
/* 可横滚的条（窗口基础能力，见 layout/stripScroll.ts） */
import '../theme/np-strip.css'
/*
 * 窗口 ABI 的类（包通过插槽放进去的控件也要吃到）——
 * ⚠️ 必须是**全局**样式：NpArea 自己的是 scoped，插槽内容拿不到它的作用域。
 */
import '../theme/np-area.css'

/*
 * ⚠️ 2027：这里原来引三份 Vue Flow 的样式（core / controls / minimap）。
 * 画布换成我们自己的之后，样式全在 `graph/canvas/np-canvas.css` 里，
 * 而那份由 `NpCanvas.vue` 自己 import —— 应用入口不该知道画布内部
 * 有几个文件（这正是"依赖方向"该有的样子）。
 */

/*
 * ⚠️ 下面这份 `data` 是**开发夹具**，不是内核的一部分。
 *
 * 数据源节点（`data.field` / `data.has`）读的就是它 ——
 * 真实集成方通过同一个属性注入自己的数据，内核**不预置任何数据**。
 * 这里放一份是为了让 dev 起来就能试：加一个「数据 · 取字段」节点，
 * 数据源填 `order`、字段填 `f_weight`，就能看到值。
 *
 * ⚠️ 也**不会**往画布上放任何节点 —— 初始画布永远是空的。
 */
const DEV_DATA = {
  order: {
    f_trackingNo: 'SF1234567890',
    f_weight: 12.5,
    f_insured: true,
    f_items: [12, 8, 30, 4],
  },
}

createApp(Playground, { data: DEV_DATA }).mount('#app')
